export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/tubly-%E2%80%94-smart-youtube/ilkjdgphnmiloepchokmhoanndcahhbc";

export const TUBLY_PROTOCOL_URL = "web+tubly://open?from=landing";